<template>
    <div ref="chartRef" class="disease-chart" :style="{ height }"></div>
</template>

<script>
export default {
    name: 'DiseaseChart',
    props: {
        option: {
            type: Object,
            default: null,
        },
        height: {
            type: String,
            default: '320px',
        },
    },
    data() {
        return {
            chart: null,
            hadZeroSize: false,
            resizeObserver: null,
        };
    },
    watch: {
        option: {
            deep: true,
            handler() {
                this.renderChart();
            },
        },
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.handleResize);
        this.bindResizeObserver();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    methods: {
        initChart() {
            if (!this.$refs.chartRef) return;
            this.chart = this.$echarts.init(this.$refs.chartRef);
            this.renderChart();
            this.$nextTick(() => {
                this.handleResize();
            });
        },
        bindResizeObserver() {
            if (typeof ResizeObserver === 'undefined' || !this.$refs.chartRef) return;
            this.resizeObserver = new ResizeObserver(() => {
                this.handleResize();
            });
            this.resizeObserver.observe(this.$refs.chartRef);
        },
        renderChart() {
            if (this.chart && this.option) {
                this.chart.setOption(this.option, true);
            }
        },
        handleResize() {
            if (!this.chart || !this.$refs.chartRef) return;
            const { clientWidth, clientHeight } = this.$refs.chartRef;
            // tab 隐藏时宽高为 0，跳过并标记，待显示后再重算
            if (!clientWidth || !clientHeight) {
                this.hadZeroSize = true;
                return;
            }
            this.chart.resize();
            // 从隐藏切回可见后，重新 setOption，让 sankey / graph 按真实尺寸重布局
            if (this.hadZeroSize && this.option) {
                this.hadZeroSize = false;
                this.chart.setOption(this.option, true);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.disease-chart {
    width: 100%;
}
</style>
